import * as React from 'react'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import { vehiclesRoutes } from './routes'
import { vehiclesPath } from './index'
import { VEHICLE_ROUTES } from './routes-typed'
import { toRelativeRoute, wrapRoutesWithRouter } from '../shared/utils/routerPaths'

const wrappedVehiclesRoutes = wrapRoutesWithRouter(vehiclesRoutes)
import { VehiclesLayout } from './VehiclesLayout'
import { AppLayoutDahboardWithNav } from '../shared/layouts'
import { ErrorBoundary } from '../shared/components/ErrorBoundary'
import { ErrorFallback } from '../shared/components/ErrorFallback'
import { VehiclesProvider } from '../shared/context/vehicles/VehiclesContext'
import { TaskProvider } from '../shared/context/TaskContext'

const VehiclesModuleImpl: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>()

  return (
    <ErrorBoundary
      fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}
    >
        <TaskProvider>

            <VehiclesProvider>
                <AppLayoutDahboardWithNav>
                  <ErrorBoundary
                    fallback={(e) => (
                      <ErrorFallback error={e.error} onRetry={e.reset} />
                    )}
                  >
                    <Routes>
                      {wrappedVehiclesRoutes.map((route) => (
                        <Route
                            key={route.path}
                            path={`${toRelativeRoute(route.path, vehiclesPath)}/*`}
                            element={
                              <VehiclesLayout
                                companyId={companyId!}
                                viewControlBar={route.viewControlBar}
                                navigation={route.navigation}
                                heightScreen={route.heightScreen}
                              >
                                <route.Component />
                              </VehiclesLayout>
                            }
                          />
                      ))}

                      <Route
                        index
                        element={
                          <Navigate
                            to={VEHICLE_ROUTES.list.buildPath({
                              companyId: companyId!,
                            })}
                            replace
                          />
                        }
                      />
                      <Route
                        path="*"
                        element={
                          <Navigate
                            to={VEHICLE_ROUTES.list.buildPath({
                              companyId: companyId!,
                            })}
                            replace
                          />
                        }
                      />
                    </Routes>
                  </ErrorBoundary>
                </AppLayoutDahboardWithNav>
            </VehiclesProvider>
        </TaskProvider>
    </ErrorBoundary>
  )
}

export const VehiclesModule = VehiclesModuleImpl
